import { render, staticRenderFns } from "./InboxSettings.vue?vue&type=template&id=702ed6d5&scoped=true&"
import script from "./InboxSettings.vue?vue&type=script&lang=ts&"
export * from "./InboxSettings.vue?vue&type=script&lang=ts&"
import style0 from "./InboxSettings.vue?vue&type=style&index=0&id=702ed6d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ed6d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow,VSwitch})
